import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

export function syncQueryParamsWithControls(
    formGroup: UntypedFormGroup,
    router: Router,
    route: ActivatedRoute
): Promise<boolean> {
    return router.navigate([], {
        queryParams: formGroup.value,
        relativeTo: route,
        queryParamsHandling: 'merge',
    });
}
